<div class="flex flex-col gap-3">
	<div class="flex">
		<app-radio-group
			label="Usage"
			[items]="propertyUsageTypes"
			type="compact"
			[ngModel]="_propertyType?.usage"
			class="mt-2"
			(ngModelChange)="propertyUsageUpdated($event)"
			[labelIcon]="AI_ICON"
			[labelToolTip]="
				(fieldMappings$ | async)?.propertyDetails?.propertyType?.usage
					? AI_TOOLTIP
					: ''
			"
			[labelIconClasses]="AI_CLASSES"
			[testHook]="testHooks.UsageRadioGroup"
		></app-radio-group>
	</div>

	<app-property-type-selection
		(onPropertyTypeChange)="onPropertyTypeChange($event)"
		[propertyType]="_propertyType"
	></app-property-type-selection>

	<div class="flex" *ngIf="showCondition" [@openClose]>
		<app-radio-group
			label="Condition"
			class="w-1/3 pr-2"
			[items]="propertyStatus"
			[ngModel]="_propertyType?.status"
			[labelIcon]="AI_ICON"
			[labelToolTip]="
				(fieldMappings$ | async)?.propertyDetails?.propertyType?.status
					? AI_TOOLTIP
					: ''
			"
			[labelIconClasses]="AI_CLASSES"
			type="compact"
			(ngModelChange)="propertyStatusUpdated($event)"
			[testHook]="testHooks.ConditionRadioGroup"
		></app-radio-group>
	</div>

	<div class="flex flex-col gap-2">
		<div [@openClose]>
			<span>Owner occupancy</span>
			<div class="ml-2 mt-1">
				<app-checkbox
					type="clear"
					label="Owner resides at subject property"
					[ngModel]="ownerResidesAtProperty"
					(ngModelChange)="setOwnerResidesInSubjectProperty($event)"
					[testHook]="testHooks.OwnerResidesAtSubjectPropertyCheckbox"
				></app-checkbox>
			</div>

			@if (ownerResidesAtProperty && fileType_() === matterFileType.SALE) {
				<div class="mt-4 mb-2 ml-2">
					<app-date-picker
						label="Planned move-out date"
						[ngModel]="ownerResidesAtPropertyMoveoutDate"
						(ngModelChange)="setOwnerResidesAtPropertyMoveoutDate($event)"
						[testHook]="testHooks.OwnerResidesAtPropertyMoveoutDatePicker"
					></app-date-picker>
				</div>
			}
		</div>

		<div class="flex flex-col" *ngIf="showTenanted" [@openClose]>
			<span>Rental details (optional)</span>
			<div class="ml-2 mt-1">
				<app-checkbox
					type="clear"
					label="Tenanted"
					[ngModel]="_propertyType?.tenanted"
					(ngModelChange)="propertyTenantedUpdated($event)"
					[testHook]="testHooks.TenantedCheckbox"
				></app-checkbox>
			</div>
			@if (_propertyType?.tenanted && fileType_() === matterFileType.SALE) {
				<div class="ml-2 mt-2 mb-3">
					<app-tenants-form />

					@if (_propertyType?.tenants?.length > 0) {
						<div>
							<app-tenants-list
								[tenants_]="_propertyType?.tenants"
							></app-tenants-list>
						</div>
					}
				</div>
			}

			<div *ngIf="showMultiUnit">
				<div class="ml-2 mt-1">
					<app-checkbox
						type="clear"
						*ngIf="_propertyType?.usage === propertyUsages.RESIDENTIAL"
						label="Multi-unit"
						[ngModel]="_propertyType?.multiUnit"
						(ngModelChange)="propertyMultiUnitUpdated($event)"
						[@openClose]
						[testHook]="testHooks.MultiUnitCheckbox"
					></app-checkbox>
				</div>
				<div
					*ngIf="_propertyType?.multiUnit"
					[@openClose]
					class="flex flex-col p-2 rounded-xl bg-grey-lighter"
				>
					<div class="flex">
						<app-radio-group
							label="Unit type"
							type="compact"
							[items]="unitTypes"
							[ngModel]="_propertyType.unitType"
							(ngModelChange)="setUnitType($event)"
							[testHook]="testHooks.UnitTypeRadioGroup"
						></app-radio-group>
					</div>
					<div class="flex">
						<app-radio-group
							label="Number of units"
							type="compact"
							[items]="numberOfUnits"
							[ngModel]="_propertyType.numberOfUnits"
							(ngModelChange)="setUnitNumber($event)"
							[testHook]="testHooks.NumberOfUnitsRadioGroup"
						></app-radio-group>
					</div>
				</div>
			</div>
		</div>

		<div class="flex flex-col" [@openClose]>
			<span>Parcel of tied land</span>
			<div class="ml-2 mt-1 mb-2">
				<app-checkbox
					label="Subject property is POTL"
					type="clear"
					[ngModel]="_propertyType?.parcelOfTiedLand"
					(ngModelChange)="propertyStatusParcelUpdated($event)"
					[testHook]="testHooks.SubjectPropertyIsPOTLCheckbox"
				></app-checkbox>
				<div class="mt-4">
					<app-parcel-of-tied-land-form
						*ngIf="_propertyType?.parcelOfTiedLand && !_propertyType?.condoPlan"
						[showCancelBtn]="false"
						[testHook]="testHooks.ParcelOfTiedLandForm"
					></app-parcel-of-tied-land-form>
					<app-parcel-of-tied-land-overview
						*ngIf="
							_propertyType?.parcelOfTiedLand &&
							_propertyType.condoPlan &&
							showCondoPlanOverview
						"
					></app-parcel-of-tied-land-overview>
				</div>
			</div>
		</div>
		@if (fileType_() === matterFileType.SALE) {
			<div>
				<app-rental-equipment />
			</div>
		}
	</div>
</div>
